// @ts-nocheck
/* eslint-disable */
import SceneGeometrySmart from "~/scene/geometry/smart";
import SceneCoords from "~/scene/common/coords";
import { store } from "~/state/store";

export default class SceneGeometrySmartPubt extends SceneGeometrySmart {
	constructor(scene, itemId, type, id, coords, options) {
		super(scene, itemId, type, id, coords, options);
	}

	setOptions(options) {
		for (let p in options) { this._options[p] = options[p]; }

		this._geometries.forEach(g => {
			if (g.getType() !== this._scene.GEOMETRY.CIRCLE) {
				g.setOptions(this._options);
			}
		});
	}

	_prepareVisibleParts() {
		let size = this._scene.getSize();
		let sizeKey = size.x + "|" + size.y;
		const { longitude, latitude, zoom } = store.getState().map;
		let posKey = longitude + "|" + latitude + "|" + zoom;
		let minDist = this._options.minDist;
		let offset = size.clone().scale(0.5);
		let rb = offset.clone();
		let lt = rb.clone().scale(-1);
		let result = [];
		let pixels = [];
		let coords = [];
		let indexes = [];
		let fullPixels = [];
		let points = [];
		let geometriesNum = -1;

		while (this._geometries.length) {
			this._geometries.pop().destroy();
		}

		let coordsArray = this._coords[0] instanceof SceneCoords ? [this._coords] : this._coords;

		coordsArray.forEach((c, index) =>{
			let prev = null;
			let prevInMap = false;
			let nextInMap = false;
			let firstInMap = false;
			let lastInMap = false;

			if (geometriesNum < 0 || (geometriesNum >= 0 && pixels[geometriesNum].length)) { // pokud mame nejakou predchozi cast, zacneme novou, pokud je cast prazdna, pridavame do aktualni
				geometriesNum++;
				pixels[geometriesNum] = [];
				coords[geometriesNum] = [];
				indexes[geometriesNum] = [];
			}

			if (c.length > 100) { // pokud mame vice jak 100 bodu delame magii
				let startIndex = geometriesNum;
				let endIndex = geometriesNum;

				for (let i = 0; i < c.length; i++) {
					let itemC = c[i];
					let inMap = true;
					let item = itemC;

					if (itemC instanceof SceneCoords) { // souradnice
						item = this._scene.coordsToPixel(itemC);
						let nextItem = i+1 <= c.length-1 ? this._scene.coordsToPixel(c[i+1]) : null;
						let lastDistance = prev ? prev.distance(item) : 0;

						if (!(item.x >= lt.x && item.x <= rb.x && item.y >= lt.y && item.y <= rb.y)) { // zkontrolujeme, zda je bod v mape
							inMap = prevInMap ? true : false; // pokud je to 1. bod ktery videt nejde a predchozi byl v mape, tak take jeste pridame
							prevInMap = false; // oznacime, ze neni v mape
						}
						else {
							prevInMap = true;
						}

						if (!inMap && nextItem && (nextItem.x >= lt.x && nextItem.x <= rb.x && nextItem.y >= lt.y && nextItem.y <= rb.y)) { // kontrola, zda nasledujici bod bude v mape, ale aktualni neni
							inMap = true;
							prevInMap = true;
							nextInMap = true;
							if (pixels[geometriesNum].length) { // pokud mame nejakou predchozi cast, zacneme novou, pokud je cast prazdna, pridavame do aktualni
								geometriesNum++;
								pixels[geometriesNum] = [];
								coords[geometriesNum] = [];
								indexes[geometriesNum] = [];
							}
						}

						// pozor - u elipsy a kruhu neni tato optimalizace zadouci
						if (!(inMap && !prevInMap) && !nextInMap && prev && lastDistance <= minDist && this._type != this._scene.GEOMETRY.ELLIPSE && this._type != this._scene.GEOMETRY.CIRCLE) {
							if (this._type == this._scene.GEOMETRY.PATH) { // pokud se jedna o PATH, musime odstranit vse k predchozimu pismenku vcetne
								let index = result.length - 1;

								while (index && typeof(result[index]) != "string") { index--; }
								result.splice(index);
							}

							fullPixels.push(item.clone());
							if (inMap) {
								indexes[geometriesNum].push(i);
							}

							continue;
						}

						prev = item.clone();

						if (inMap) {
							pixels[geometriesNum].push(prev);
							coords[geometriesNum].push(itemC);
							indexes[geometriesNum].push(i);

							if (i == 0) {
								firstInMap = true;
							}
							else if (i == c.length-1) {
								lastInMap = true;
							}
						}

						fullPixels.push(prev);
						item.plus(offset);
					}

					if (inMap) {
						result.push(item);
					}

					endIndex = geometriesNum;
				}

				if (this._options.createPoints) {
					firstInMap && points.push(c[0]);
					lastInMap && points.push(c[c.length-1]);
				}

				if (startIndex != endIndex && firstInMap && lastInMap && this._type == this._scene.GEOMETRY.POLYGON) {
					pixels[startIndex] = pixels.pop().concat(pixels[startIndex]);
					coords[startIndex] = coords.pop().concat(coords[startIndex]);
					indexes[startIndex] = indexes.pop().concat(indexes[startIndex]);
					geometriesNum--;
				}
			}
			else { // pokud mame <= 100 bodu, bereme vsechny souradnice geometrie
				c.forEach((i,k) => {
					let pixel = this._scene.coordsToPixel(i);

					pixels[geometriesNum].push(pixel);
					coords[geometriesNum].push(i);
					indexes[geometriesNum].push(k);
					fullPixels.push(pixel);

					this._options.createPoints && (k === 0 || k === c.length-1) && points.push(i);
				});
			}
		});

		if (pixels.length > 1 && !pixels[pixels.length-1].length) {
			pixels.pop();
			coords.pop();
			indexes.pop();
		}

		for (let i = 0; i < coords.length; i++) {
			if (pixels[i].length < 2) { continue; }

			let simplified = this._simplify(pixels[i], coords[i], 0.6);
			this._geometries.push(this._scene.createGeometry(this._type == this._scene.GEOMETRY.POLYGON && this._options.clickable ? this._scene.GEOMETRY.POLYGON : this._scene.GEOMETRY.POLYLINE, null, simplified.coords, this._options));
		}

		points.forEach(point => {
			if (point) {
				this._geometries.push(this._scene.createGeometry(this._scene.GEOMETRY.CIRCLE, null, [point, 2], {
					...this._options,
					color: "#fff",
					opacity: 1,
					outlineWidth: 0,
					outlineOpacity: 0,
					outlineColor: "#fff",
				}));
			}
		})

		// save to cachce
		this._pixelsData.sizeKey = sizeKey;
		this._pixelsData.posKey = posKey;
		this._pixelsData.pixels = pixels;
		this._pixelsData.fullPixels = fullPixels;
		this._pixelsData.indexes = indexes;
	}
}
